export default "__VITE_ASSET__07ae4d81__"